import React, { Component } from "react";
import SupplierWeb from "../../components/supplierWeb/index";
import * as actions from "../../common/sysco-ui-components/store/actions/tabViewAction";
import {
  dashboard,
  getRecentChecks,
  getPendingPayableReport,
  login,
  getVendorDownloadLinks
} from "../../store/actions/dashboardAction";
import { connect } from "react-redux";

import history from "../../utils/history";
import Axios from "axios";
import  cookie from "react-cookies";
import { store } from "../..";
import { LOGIN } from "../../store/actions/actionTypes";
import responseDetailsContainer from "../responseDetailsContainer";
import { SUPPLIER_PATH, VERIFY_SESSION_PATH } from "../../config/path";
class SupplierWebDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vendorDownloadLinks: [],
      dailyPendingPayablesReport: [],
      vendorList:
        localStorage.getItem("subvendorList") &&
        localStorage.getItem("subvendorList").split(",")
    };
  }
  async componentDidMount() {
    try {
      const authCheck = await Axios.get(VERIFY_SESSION_PATH);
      if (!authCheck.data.authenticated) {
        history.push("/");
        return;
      }

      this.getSubvendorList();
      store.dispatch({ type: LOGIN });
      document.getElementById('headerUserName').innerHTML = "Welcome    " + cookie.load('userName');
      this.props.dashboardReducer.vendorDownloadLinks.length === 0 && this.props.getVendorDownloadLinks(localStorage.getItem("vendorNumber"));
    } catch (error) {
      console.error("Authentication check failed:", error);
      history.push("/");
    }
  }

  getSubvendorList = () => {
    let subvendorList = [];
    Axios({
      url: `${SUPPLIER_PATH}/get-vendornumbers-subvendors?vendorNumber=${localStorage.getItem(
        "vendorNumber"
      )}`,
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    })
      .then(res => {
        if (res.data.rows[0].myRows && res.data.rows[0].myRows.length !== 0) {
          subvendorList = res.data.rows && res.data.rows[0].myRows && res.data.rows[0].myRows.length!==0 && res.data.rows[0].myRows.map(val => val.vendorNumber);
        }
        localStorage.setItem("subvendorList", subvendorList);
        this.props.dashboardReducer.recentChecks.length===0 && this.props.getRecentChecks(subvendorList);
        this.props.dashboardReducer.pendingPayableReports.length===0 &&  this.props.getPendingPayableReport(subvendorList);
      })
      .catch(err => {
        console.log("Failed to get subvendor list", err);
      });
  };
  routeToRequestDetails = id => {
    // this.props.routeToRequestDetails(id);
    this.props.OnAddTab(`Response #:${id}`,responseDetailsContainer, {"id":id});
    // history.push(`/responsedetails/${id}`);
  };

  getToken = () => {
    this.props.login();
  };
  render() {
    return (
      <div>
        <SupplierWeb
          recentLoader={this.props.dashboardReducer.recentLoader}
          dailyLoader={this.props.dashboardReducer.dailyLoader}
          csLoader={this.props.dashboardReducer.csLoader}
          vendorLoader={this.props.dashboardReducer.vendorLoader}
          getRecentChecks={this.props.getRecentChecks}
          recentChecks={this.props.dashboardReducer.recentChecks}
          getPendingPayableReport={this.props.getPendingPayableReport}
          getVendorDownloadLinks={this.props.getVendorDownloadLinks}
          dailyPendingPayablesReport={
            this.props.dashboardReducer.pendingPayableReports
          }
          OnAddTab={this.props.OnAddTab}
          routeToRequestDetails={this.routeToRequestDetails}
          vendorDownloadLinks={this.props.dashboardReducer.vendorDownloadLinks}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    dashboardReducer: state.DashboardReducer
  };
}
const mapDispatchToProps = dispatch => {
  return {
    OnAddTab: (title, eventKey, name, type, id, viewParam) => {
      dispatch(actions.addTab(title, eventKey, name, type, id, viewParam));
    },
    getDashboard: () => {
      dispatch(dashboard());
    },
    login: () => {
      dispatch(login());
    },
    getRecentChecks: data => {
      dispatch(getRecentChecks(data));
    },
    getPendingPayableReport: data => {
      dispatch(getPendingPayableReport(data));
    },
    getVendorDownloadLinks: vendorNo => {
      dispatch(getVendorDownloadLinks(vendorNo));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupplierWebDashboard);
